import React, { useState } from 'react';
import { components as selectComponents } from 'react-select';
import AsyncSelect from 'react-select/async';
import { useSelector } from 'react-redux';
import { MultipleValuesContainer as MultiValue } from './MultiValueComponent';
import './select.scss';
import { selectStyles } from './selectStyles';

const AutoSuggestionSelectComponent = (props) => {
  const themeColors = useSelector((state) => state.theme.themeValuesObject);
  const {
    inputClassName,
    components,
    options,
    fetchOptions,
    isClearable,
    ...otherProps
  } = props;
  const [selectClassName, setSelectClassName] = useState('');

  const customStyles = selectStyles({ themeColors });

  const Input = (props) => {
    return (
      <selectComponents.Input
        value="med"
        {...props}
        maxLength={50}
        minLength={3}
      />
    );
  };
  const defaultComponents = { MultiValue, Input, MultiValueRemove: () => null };

  const loadOptions = async (inputValue, callback) => {
    if (inputValue.length < 3) {
      callback([]);
    } else {
      try {
        const res = await fetchOptions(inputValue);
        if (res?.length) {
          callback([...res]);
        } else {
          callback([]);
        }
      } catch (error) {
        callback([]);
      }
    }
  };

  const noOptionsMessage = (input) => {
    if (input.inputValue.length === 0) {
      return 'Type to search';
    } else if (input.inputValue.length < 3) {
      return 'Search input must be at least 3 characters';
    } else {
      return 'No options';
    }
  };

  return (
    <AsyncSelect
      {...otherProps}
      styles={customStyles}
      className={`generic-select ${inputClassName} ${selectClassName}`}
      onFocus={() => setSelectClassName('select-focus-border-admin')}
      onBlur={() => setSelectClassName('')}
      components={
        components ? { ...defaultComponents, ...components } : defaultComponents
      }
      isClearable={isClearable}
      hideSelectedOptions={false}
      classNamePrefix={'generic-select-prefix'}
      noOptionsMessage={noOptionsMessage}
      loadOptions={loadOptions}
      cacheOptions={false}
      filterOption={false}
    />
  );
};

export default AutoSuggestionSelectComponent;
export { selectComponents as components };
